export default __webpack_public_path__ + "static/media/vue.1eafbd69.png";